/**
 * Centralized, frozen authentication constants and enums for proxima_blue2.
 * Eradicates magic strings and numbers across auth composables, guards, and pages.
 */

export const AUTH_STORAGE_KEYS = Object.freeze({
  JWT: "Jwt",
  REFRESH_TOKEN: "RefreshToken",
  INVITE_TOKEN: "invite_token",
  INVITE_DATA: "invite_data",
  USER_EMAIL: "email",
});

export const AUTH_ROUTES = Object.freeze({
  LOGIN: "/login",
  CALLBACK: "/callback",
  INVITE_SIGNUP: "/invite-signup",
  DASHBOARD: "/app/dashboard",
  AUTH_FAILURE: "/auth-failure",
});

export const AUTH_FAILURE_REASONS = Object.freeze({
  DEACTIVATED: "deactivated",
  ORGANIZATION_RESTRICTION: "organization_restriction",
  EMAIL_MISMATCH: "email_mismatch",
  EXPIRED_INVITE: "expired_invite",
  INVALID_TOKEN: "invalid_token",
  SIGNIN_FAILURE: "signin_failure",
  SERVER_ERROR: "server_error",
});

export const HTTP_STATUS = Object.freeze({
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  INTERNAL_SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
});
